/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SavedPriceInfo
 */
export interface SavedPriceInfo {
    /**
     * 
     * @type {number}
     * @memberof SavedPriceInfo
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof SavedPriceInfo
     */
    priceUnitId: number;
    /**
     * 
     * @type {Date}
     * @memberof SavedPriceInfo
     */
    validFrom: Date;
}

/**
 * Check if a given object implements the SavedPriceInfo interface.
 */
export function instanceOfSavedPriceInfo(value: object): value is SavedPriceInfo {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    return true;
}

export function SavedPriceInfoFromJSON(json: any): SavedPriceInfo {
    return SavedPriceInfoFromJSONTyped(json, false);
}

export function SavedPriceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedPriceInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'priceUnitId': json['priceUnitId'],
        'validFrom': (new Date(json['validFrom'])),
    };
}

export function SavedPriceInfoToJSON(json: any): SavedPriceInfo {
    return SavedPriceInfoToJSONTyped(json, false);
}

export function SavedPriceInfoToJSONTyped(value?: SavedPriceInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'priceUnitId': value['priceUnitId'],
        'validFrom': (formatDateOnly(value['validFrom'])),
    };
}

